// extracted by mini-css-extract-plugin
export default {"titleRender":"RenderCardTitle_titleRender__mjoxf","buttonImage":"RenderCardTitle_buttonImage__Bfajl","image":"RenderCardTitle_image__istaU"};